import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('jwt_token'));
  const [roles, setRoles] = useState(() => {
    try { return JSON.parse(localStorage.getItem('jwt_roles') || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    const storedToken = localStorage.getItem('jwt_token');
    const storedUser  = localStorage.getItem('jwt_user');
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(storedUser);
    }
  }, []);

  const login = (tokenValue, username, userRoles = []) => {
    localStorage.setItem('jwt_token', tokenValue);
    localStorage.setItem('jwt_user', username);
    localStorage.setItem('jwt_roles', JSON.stringify(userRoles));
    setToken(tokenValue);
    setUser(username);
    setRoles(userRoles);
  };

  const logout = () => {
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('jwt_user');
    localStorage.removeItem('jwt_roles');
    setToken(null);
    setUser(null);
    setRoles([]);
  };

  return (
    <AuthContext.Provider value={{
      user, token, roles,
      isSuperAdmin: roles.includes('ROLE_SUPER_ADMIN'),
      login, logout,
      isAuthenticated: !!token,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
